import { Injectable } from '@angular/core';
import { AppStateService } from './appstate.service';
import { BrowserService } from './browser.service';
import { AuthenticationService } from './AuthService/auth.service';
import { StorageKeys } from '@shared/constants/storage-keys.constants';

@Injectable({
    providedIn: 'root'
})
export class AppInitializerService {

    constructor(
        private authService: AuthenticationService,
        private browserService: BrowserService,
        private appStateService: AppStateService
    ) { }

    async init(): Promise<void> {

        // If is intialize won't intiazlize again until Log out
        if (this.appStateService.isInitialized()) {
            return;
        }

        const userName = this.browserService.getItem(StorageKeys.USER_NAME);
        const token = this.browserService.getItem(StorageKeys.TOKEN);

        if (!this.authService.isLoggedIn || !userName || !token) {
            return;
        }

        this.appStateService.setInitialized(true);
    }
}
